export default __webpack_public_path__ + "static/media/Level38.d773343b.svg";